exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".app-copyright[data-v-37fa5daa]{margin-top:16px;padding-bottom:20px;font-size:12px;text-align:center;color:#bcbcbc;line-height:20px}", "", {"version":3,"sources":["/home/hanzhu/nutstore-webpages/js_src_vue/src/components/copyright/index.vue?vue&type=style&index=0&id=37fa5daa&lang=scss&scoped=true&"],"names":[],"mappings":"AAAA,gCAAgC,gBAAgB,oBAAoB,eAAe,kBAAkB,cAAc,gBAAgB,CAAC","file":"index.vue?vue&type=style&index=0&id=37fa5daa&lang=scss&scoped=true&","sourcesContent":[".app-copyright[data-v-37fa5daa]{margin-top:16px;padding-bottom:20px;font-size:12px;text-align:center;color:#bcbcbc;line-height:20px}"],"sourceRoot":""}]);

// exports
